/**
 * Internal dependencies
 */
import * as actions from './actions';

export function* getSettings() {
	const query = '/gutenify/v1/get_settings/';
	const settings = yield actions.apiFetch( { path: query } );

	return actions.setSettings( settings );
}

export function* getSiteOptions() {
	const query = '/gutenify/v1/get_site_options/';
	const settings = yield actions.apiFetch( { path: query } );

	return actions.setSiteOptions( {
		settings,
		coreSettings: {},
	} );
}
